import { Form, Input } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import React from 'react'

function AddPackageForm (props) {
  const { tracking, payload, setPkgInfo, remove, submit, update, submitting } = props
  const { getFieldDecorator } = props.form

  const pkg = get(payload, 'object')
  const isNew = !pkg
  const sales = get(tracking, 'sales._id', '').replace('sales/', '')

  const [PackageSelect] = useFetchSelectUrl(
    {
      name: 'package',
      url: `package/?select=*&sales=${sales}`,
      // url: `package/?select=_id,_rev,_key,code`,
      cache: true,
    },
    [sales],
    isEmpty(sales),
  )

  return (
    <>
      <Form.Item {...defaultFormItemLayout} label="Package">
        {getFieldDecorator('_id', {
          initialValue: get(pkg, '_id'),
          rules: rules.select,
        })(
          <PackageSelect
            keyAtr={'_id'}
            valueAtr={'code'}
            setSelected={setPkgInfo}
            placeholder="Select a Quote"
            style={{ width: '100%' }}
          />,
        )}
      </Form.Item>
      <Form.Item {...fullWidthFormItemLayout} label={'Info'}>
        {getFieldDecorator('info', {
          initialValue: get(pkg, 'info'),
        })(<Input.TextArea rows={4}/>)}
      </Form.Item>

      <FooterButtons
        style={{ marginBottom: 10 }}
        remove={remove}
        removing={submitting}
        submit={submit}
        update={update}
        submitting={submitting}
        title={'Packages'}
        isNew={isNew}
        isEdit={!isNew}
      />
    </>
  )
}

export default Form.create()(AddPackageForm)
